<div class="container-fluid" style="margin-bottom: 20px; padding-bottom: 20px;">
  <p-panel>
    <ng-template pTemplate="header" class="eca-secondary-bg" style="color: white">
      <div class="col">
        <h3 style="margin-bottom: 0 !important;">
          <span style="margin-left: 15px;"><fa-icon [icon]="['fas', 'books']"> </fa-icon> All Operative Documents </span>
        </h3>
      </div>
      <div class="col pull-right">
        <app-eca-ghost-btn class="card-action-icon float-right" btnIcon="question-circle" btnType="warning" (btnClicked)="openOperativesDocumentsHelp()">
        </app-eca-ghost-btn>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <div class="container-fluid " style="padding-left: 0; padding-right: 0;">
        <div *ngIf="operativeDocumentsLoading" class="text-center">
          <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
        </div>
        <div *ngIf="!operativeDocumentsLoading">
          <app-operative-documents *ngIf="operativeDocumentSummaries"
                                   [showTableCaption]="true"
                                   [showHeaderText]="true"
                                   [operativeDocuments]="operativeDocumentSummaries"
                                   [allowedOperations]="loggedInUser?.documentOperations"
                                   (openDocument)="openOperativeDocument($event)"
                                   (editDocument)="editOperativeDocument($event)"
                                   (deleteDocument)="deleteOperativeDocumentClick($event)"
                                   (viewDocument)="viewOperativeDocument($event)"
                                   (downloadDocument)="downloadOperativeDocument($event)"
                                   (refreshDocumentsRequested)="refreshDocuments($event)"
                                   [showAddDocumentButton]="false">
          </app-operative-documents>
        </div>
      </div>
    </ng-template>
  </p-panel>
</div>
